

import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import PazAjaxTable from "../../components/layout/PazAjaxTable.vue";
import PazTextSearch from "../../components/controls/PazTextSearch.vue";
import PazConfirmation from "../../components/utils/PazConfirmation.vue";
import PazRefreshButton from "../../components/controls/PazRefreshButton.vue";
import PazTooltipButton from "../../components/controls/PazTooltipButton.vue";
import PazClipboardButton from "../../components/controls/PazClipboardButton.vue";
import EditGroupDialog from "./EditGroupDialog.vue";
import {
  addUserToGroup,
  getGroupById,
  getGroupMembersFor,
  getUsers,
  removeUserFromGroup
} from "../../services/auth-service";
import {ApiGroup} from "../../models/user-models";

@Component({
  components: {
    PazClipboardButton,
    EditGroupDialog,
    PazTooltipButton,
    PazConfirmation,
    PazTextSearch,
    PazAjaxTable,
    PazRefreshButton,
  },
})
export default class GroupDetailList extends Vue {


  public loading: boolean = true;
  public groupId: number = 0;
  public members: Array<number> = [];
  public groupInfo: ApiGroup | null = null;
  public search: string = "";
  public groupMembers: object[] = [];
  public users: object[] = [];
  public actionPending: boolean = false;
  public headers: object[] = [
    {
      text: "Member",
      align: "left",
      sortable: true,
      value: "member",
    },
    {
      text: "Email",
      align: "left",
      sortable: true,
      value: "username",
    },
    {
      text: "Name",
      align: "left",
      sortable: true,
      value: "name",
    },
    {
      text: "Action",
      align: "right",
      sortable: true,
      value: "extra",
    },
  ];
  showEditDialog: boolean = false;
  selectedId: number | null = null;


  $refs!: {
    confirm: PazConfirmation;
    response: PazConfirmation;
    confirmWarn: PazConfirmation;
  };


  public membersOnly: boolean = false;

  get filteredItems() {
    if (this.membersOnly) {
      return this.users.filter(user => {
        return this.members.includes(user.id);
      });
    }
    return this.users;
  }

  public isMember(item: any) {
    return this.members.includes(item.id);
  }

  async fetchData() {
    this.loading = true;
    this.members= [];
    const l = await getGroupMembersFor(this.groupId);
    for (let member in l.users) {
      this.members.push(l.users[member].id);
    }
    // console.log(this.groupMembers);
    this.groupInfo = await getGroupById(this.groupId);
    this.users = await getUsers();
    this.loading = false;
  }

  async confirmDeletion(user: any) {

    const confirm = await this.$refs.confirm.openConfirmDialog(
        "Delete",
        "Are you sure you want to delete `" + user.name + "`?"
    );
    if (confirm) {
      // const response = await deleteGroup(user.id);
      // if (response) await this.fetchData();
    }
  }

  async addToGroup(id: number) {
    this.actionPending = true;
    let rsp = await addUserToGroup(id, this.groupId);
    if (rsp.user) {
      this.members.push(rsp.user);
    }
    this.actionPending = false;
  }

  async removeFromGroup(id: number) {
    this.actionPending = true;
    let rsp = await removeUserFromGroup(id, this.groupId);
    if (rsp.user) {
      const index = this.members.indexOf(rsp.user, 0);
      if (index > -1) {
        this.members.splice(index, 1);
      }
    }
    this.actionPending = false;
  }

  get getGroupName() {
    return this.groupInfo?.name;
  }

  public mounted() {
    this.groupId = Number(this.$route.params.id);
    this.fetchData();
  }
}
